import React from "react";

import "./Radio.scss";

export type RadioProps = {
  label?: string;
  name: string;
  value?: string | number;
  onChange?: any;
  noBorder?: boolean;
  inline?: boolean;
  disabled?: boolean;
  checked?: boolean;
};

export const Radio: React.FC<RadioProps> = ({
  label,
  name,
  value,
  onChange,
  noBorder = false,
  inline = false,
  disabled = false,
  checked = false,
  children,
}) => {
  return (
    <label
      className={`Radio ${noBorder ? "no-border" : ""} ${
        inline ? "inline" : ""
      }`}
    >
      <input
        type={"radio"}
        name={name}
        value={value ?? label}
        onChange={onChange}
        disabled={disabled}
        defaultChecked={checked}
      />
      <div className={"radio-wrapper"}>
        <div className={`outline ${disabled}`}>
          <div className={"dot"} />
        </div>
        {label && <span>{label}</span>}
        <div className="body">{children}</div>
      </div>
    </label>
  );
};
